import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { v, au } from '../koko-framework/shorthand'
// import app from '../koko-framework/app'
import * as PIXI from 'pixi.js'
import { GAME_ORDER, PIGPEN, CAESAR, FREQUENCY } from '../model/GameModel'
import gameState from '../model/GameModel'
import { setupClicker } from '../controller/ButtonController'

const UNLOCK_ALL_GAMES = false;

export class LevelSelectView extends koko.view {
    clickAllowed = false;
    nextScreen = '';
    popOpen = false;

    /* constructor (){
        super();
    } */

    buildView (){
        // var g = app.guiSize, vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'sprite', id: 'BG_pattern', name: 'bg', x: -280, y: 0, width: 1326, height: 1355},

            { type: 'sprite', id: 'close_btn', name: 'close_btn', x: 583, y: 196, width: 75, height: 63},

            { type: 'sprite', id: 'levelselect_title', name: 'levelselect_title', x: 264, y: 286, width: 238, height: 63},

            { type: 'sprite', id: 'pigpen_levelSelect', name: 'pigpen_levelSelect', x: 102, y: 390, width: 560, height: 230},
            { type: 'sprite', id: 'caesar_levelSelect', name: 'caesar_levelSelect', x: 102, y: 652, width: 560, height: 230},
            { type: 'sprite', id: 'frequency_levelSelect', name: 'frequency_levelSelect', x: 102, y: 913, width: 560, height: 230},

            { type: 'sprite', id: 'ls_score_default', name: 'score_pp', x: 196, y: 504, width: 142, height: 53, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'ls_score_default', name: 'score_cs', x: 196, y: 766, width: 142, height: 53, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'ls_score_default', name: 'score_fr', x: 196, y: 1028, width: 142, height: 53, anchorX: 0.5, anchorY: 0.5},

            /*
            { type: 'sprite', id: 'MathsWeek_logo', name: 'mwlogo', x: 210, y: 225, width: 182, height: 76, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'openUNi_logo', name: 'oulogo', x: 589, y: 225, width: 112, height: 76, anchorX: 0.5, anchorY: 0.5},

            { type: 'sprite', id: 'Codebreak_logo', name: 'cblogo', x: vp.centerX, y: 482, width: 434, height: 330, anchorX: 0.5, anchorY: 0.5},

            { type: 'bmptext', text: 'Think you can crack the codes?\nPlay the game to find out!', font: 'typrighter_small', size: 30, tint: 0, name: 'blurbText1', align:'center', x: vp.centerX, y: 672, anchorX: 0.5, anchorY: 0},

            { type: 'sprite', id: 'playgame_btn', name: 'play_btn', x: vp.centerX, y: 840, width: 434, height: 105, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'findout_btn', name: 'findout_btn', x: vp.centerX, y: 960, width: 434, height: 105, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'share_btn', name: 'share_btn', x: 314, y: 1080, width: 298, height: 105, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'sfx_off', name: 'sound_btn', x: 535, y: 1080, width: 126, height: 105, anchorX: 0.5, anchorY: 0.5},
            */

            /*
            { type: 'shape', name: 'bg', x: -vp.x, y: -vp.y, width: vp.width + vp.x * 2, height: vp.height + vp.y * 2, fill: 0, alpha: 0.6},
            { type: 'sprite', id: 'carrier_big', name: 'bg2', x: vp.centerX, y: 678, width: 642, height: 1066, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'gameover_title', name: 'title', x: vp.centerX, y: 246, width: 268, height: 62, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'You successfully decoded the secret message\nusing frequency analysis.', font: 'typrighter_small', size: 30, tint: 0, name: 'successText', align:'center', x: vp.centerX, y: 296, anchorX: 0.5, anchorY: 0},
            { type: 'sprite', id: 'rank_1star', name: 'rank', x: vp.centerX, y: 543, width: 358, height: 356, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'feedback_banner', name: 'feedback', x: vp.centerX, y: 777, width: 466, height: 114, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'previous_header', name: 'prevhead', x: vp.centerX, y: 880, width: 224, height: 38, anchorX: 0.5, anchorY: 0.5},

            { type: 'container', name: 'prev1', x: 385, y: 936},
                { type: 'bmptext', parent: 'prev1', text: 'CAESAR CIPHER', font: 'typrighter_small', size: 30, tint: 0, name: 'prev1text', align:'left', x: -153, y: -13, anchorX: 0, anchorY: 0},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r1', x: 66, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r2', x: 99, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r3', x: 131, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
            
            { type: 'container', name: 'prev2', x: 385, y: 980},
                { type: 'bmptext', parent: 'prev2', text: 'PIG PEN', font: 'typrighter_small', size: 30, tint: 0, name: 'prev2text', align:'left', x: -153, y: -13, anchorX: 0, anchorY: 0},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r1', x: 66, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r2', x: 99, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r3', x: 131, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},

            { type: 'sprite', id: 'continue_btn', name: 'continue_btn', x: vp.centerX, y: 1090, width: 434, height: 105, anchorX: 0.5, anchorY: 0.5},
            */
        ], this.container);

        /*
        let scoresFound = false;
        for (let i = 0; i < GAME_ORDER.length - 1; i++) {
            if (gameState.gameScores[i] > 0 && gameState.currentGame > i) {
                scoresFound = true;
                this.children['prev' + (i + 1)].visible = true;
                for (let j = 1; j <= gameState.gameScores[i]; j++) {
                    this.children['prev' + (i + 1) + 'r' + j].texture = PIXI.Texture.from('rank_full.png');
                }
            } else {
                this.children['prev' + (i + 1)].visible = false;
            }
        }
        if (!scoresFound) {
            this.children.prevhead.visible = false;
        }

        this.children.successText.text = GAME_ORDER[gameState.currentGame].successMessage;

        if (gameState.gameScores[gameState.currentGame] > 1) {
            this.children.rank.texture = PIXI.Texture.from('rank_' + gameState.gameScores[gameState.currentGame] + 'stars.png');
        }
        if (gameState.gameScores[gameState.currentGame] < 3) {
            this.children.feedback.texture = PIXI.Texture.from('feedback_banner_' + gameState.gameScores[gameState.currentGame] + 'stars.png');
        }
        */

        this.resize();
    }

    resize () {
        /*
        var vp = app.viewPort;
        let bg = this.children.bg;
        bg.x = -vp.x;
        bg.y = -vp.y;
        bg.width = vp.width + Math.abs(vp.x) * 2;
        bg.height = vp.height + Math.abs(vp.y) * 2;
        */
    }

    transitionIn = () => {
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35});

        this.popOpen = false;

        // setTimeout(this.transitionOut, 3000);

        /*
        this.children.continue_btn.interactive = true;
        this.children.continue_btn.on('mousedown', this.nextGame);
        this.children.continue_btn.on('pointerdown', this.nextGame);
        this.children.continue_btn.on('touchstart', this.nextGame);
        */

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.close_btn.interactive = true;
        this.children.close_btn.on(event, () => {this.nextScreen = 'mainmenu'; this.transitionOut();});
        */
        setupClicker(this.children.close_btn, () => {this.nextScreen = 'mainmenu'; this.transitionOut();});

        let ppScore = gameState.gameScores[GAME_ORDER.indexOf(PIGPEN)];
        let csScore = gameState.gameScores[GAME_ORDER.indexOf(CAESAR)];
        let faScore = gameState.gameScores[GAME_ORDER.indexOf(FREQUENCY)];

        if (ppScore > 0) {
            this.children.score_pp.texture = PIXI.Texture.from('ls_score_' + ppScore + 'star.png');
        }
        /*
        this.children.pigpen_levelSelect.interactive = true;
        this.children.pigpen_levelSelect.on(event, () => {if (!this.popOpen) { this.popOpen = true; gameState.currentGame = 0; this.nextScreen = 'pigpenview'; v.get('ppintro').transitionIn(this) } });
        */
        setupClicker(this.children.pigpen_levelSelect, () => {if (!this.popOpen) { this.popOpen = true; gameState.currentGame = 0; this.nextScreen = 'pigpenview'; v.get('ppintro').transitionIn(this) } });

        if (ppScore > 0 || UNLOCK_ALL_GAMES) {
            if (csScore > 0) {
                this.children.score_cs.texture = PIXI.Texture.from('ls_score_' + csScore + 'star.png');
            }
            this.children.score_cs.visible = true;
            /*
            this.children.caesar_levelSelect.interactive = true;
            this.children.caesar_levelSelect.on(event, () => {if (!this.popOpen) { this.popOpen = true; gameState.currentGame = 1; this.nextScreen = 'caesarcipherview'; v.get('csintro').transitionIn(this) } });
            */
            setupClicker(this.children.caesar_levelSelect, () => {if (!this.popOpen) { this.popOpen = true; gameState.currentGame = 1; this.nextScreen = 'caesarcipherview'; v.get('csintro').transitionIn(this) } });
        } else {
            this.children.caesar_levelSelect.texture = PIXI.Texture.from('caesar_levelLocked.png');
            this.children.score_cs.visible = false;
        }

        if (csScore > 0 || UNLOCK_ALL_GAMES) {
            if (faScore > 0) {
                this.children.score_fr.texture = PIXI.Texture.from('ls_score_' + faScore + 'star.png');
            }
            this.children.score_fr.visible = true;
            /*
            this.children.frequency_levelSelect.interactive = true;
            this.children.frequency_levelSelect.on(event, () => {if (!this.popOpen) { this.popOpen = true; gameState.currentGame = 2; this.nextScreen = 'frequencyanalysisview'; v.get('frintro').transitionIn(this) } });
            */
            setupClicker(this.children.frequency_levelSelect, () => {if (!this.popOpen) { this.popOpen = true; gameState.currentGame = 2; this.nextScreen = 'frequencyanalysisview'; v.get('frintro').transitionIn(this) } });
        } else {
            this.children.frequency_levelSelect.texture = PIXI.Texture.from('frequency_levelLocked.png');
            this.children.score_fr.visible = false;
        }

        this.clickAllowed = true;
    }

    transitionOut = () => {
        au.play('button', 1, false);
        this.children.close_btn.interactive = false;
        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
        if (this.nextScreen !== '') {
            v.get(this.nextScreen).transitionIn();
        }
    }

    /*
    nextGame = (e) => {
        if (this.clickAllowed) {
            this.transitionOut();
            gameState.nextGame();
            this.clickAllowed = false;
        }
    }
    */

    popClosed = () => {
        if (this.popOpen) {
            this.popOpen = false;
            this.clickAllowed = true;
        }
    }
}